const SegmentIntegrated = ({language , token}) => {
    const newSegmentIframe = "https:" +
    window.process.env.URL_Segment
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_Segment_display"
        src={newSegmentIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default SegmentIntegrated